export function createTurn(turn) {
    let { createTurnRequest, createTurnError, createTurnResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'create_turn',
        this.createBundle('create_turn', { turn }, this.POST, createTurnRequest, createTurnResult, createTurnError)
    )
}
